import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import {
  Users,
  UserGear as UserCog,
} from '@phosphor-icons/react';

const TeamTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isServicesType = ['SERVICES', 'SALON'].includes(user?.businessType);

  const tabs = [
    { key: 'staff', label: 'Staff', icon: Users, path: `/${slug}/owner/team` },
    ...(isServicesType ? [
      { key: 'attendants', label: 'Attendants', icon: UserCog, path: `/${slug}/owner/team/attendants` },
    ] : []),
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default TeamTab;
